import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { JsonHttpService } from "src/app/shared/http/json-http.service";
import { CompanyProfile } from '../models/company-profile';
import { lastValueFrom, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CompanyProfileService {

    constructor(private httpService: JsonHttpService) {
    }

    getGetCompanyProfile(): Promise<CompanyProfile> {
        const observable = this.httpService.get('/api/company-profile/get-company-profile') as Observable<CompanyProfile>;
        return lastValueFrom(observable);
    }

    saveCompanyProfile(companyProfile: CompanyProfile): Promise<CompanyProfile> {
        const observable = this.httpService.post('/api/company-profile/save-company-profile', companyProfile) as Observable<CompanyProfile>;
        return lastValueFrom(observable);
    }
}